<res-base-modal [modalTitle]="'Generate More Reports'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="'Generate Reports'" (primaryButtonActionEmt)="generateReports()"
    (closeButtonActionEmt)="closeModal()" [isPrimaryBtnEnabled]="isPrimaryBtnEnabled()"
    [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
    [modalHelpIndex]="modalHelpIndex">

    <div class="modal-row">
        <div class="modal-row row-padding">
            <res-custom-checkbox *ngIf="!options.workFlowTaskHandle"
                [attr.data-automation-id]="modalAutomationId + '-generate-workflow-report-checkbox'"
                [(ngModel)]="options.generateWorkflowReport" (ngModelChange)="generateWorkflowReport()"
                content="Generate Workflow Report" class="generate">
            </res-custom-checkbox>
            <div [ngClass]="[!options.workFlowTaskHandle ? 'term-report' : 'export-comparison-report']">
                <res-custom-checkbox
                    [attr.data-automation-id]="modalAutomationId + '-final-search-term-report-checkbox'"
                    [(ngModel)]="options.finalSearchTermReport" (ngModelChange)="finalSearchTermReport()"
                    content="Final Search Term Report">
                </res-custom-checkbox>
                <div class="export-filter">
                    <div class="export-comparison">
                        <res-custom-checkbox
                            [attr.data-automation-id]="modalAutomationId + '-export-comparison-report-checkbox'"
                            [(ngModel)]="options.exportComparisonReport" (ngModelChange)="exportComparisonReport()"
                            content="Export Comparison Report:" *ngIf="hasExportPermissions">
                        </res-custom-checkbox>
                    </div>
                    <div class="export-filter-input">
                        <input type="text" [ngModel]="options.selectedExportName" readonly="true"
                            [attr.data-automation-id]="modalAutomationId + '-export-name-label'">
                        <button class="filter-clear" *ngIf="options.selectedExportName.trim()"
                            (click)="clearExportFilter()"
                            [attr.data-automation-id]="modalAutomationId + '-export-name-clear-button'">
                            <i class="fa fa-times"></i>
                        </button>
                        <button type="button" [attr.data-automation-id]="modalAutomationId + '-select-export-button'"
                            class="secondary-button" (click)="openTargetPicker()"
                            [disabled]="!options.exportComparisonReport">
                            Select Export...
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</res-base-modal>